/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { getForm } from '../../../../utils/reducerHalpers/formFields';
import { createReducerDotPathName } from './naming';

const getState = (state, reducerName) =>
  _.get(state, createReducerDotPathName(reducerName));

export const selectState = (state, reducerName) => getState(state, reducerName);

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectFieldSum = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.sum');

export const selectFieldOutputAccountsType = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.payout_accounts_type');

export const selectFieldAccountNumber = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.account_number');

export const selectHasFormDisabled = (state, reducerName) =>
  _.get(getState(state, reducerName), 'hasInputDisabled');

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/selectors.js